import { Button, Modal, ModalInner } from 'components';

interface ModalProps {
  isOpen: boolean;  // 모달의 열림 상태
  onCancel: () => void;  
}

const DeleteCompleteModal = ({ isOpen, onCancel }: ModalProps) => {
  return (
    <Modal isOpened={isOpen}>
      <ModalInner className="md:w-[400px]" title="Deletion Completed" onClickClose={onCancel}>
        <p className="p-4 pt-0 text-body1">
          Your ID has been successfully deleted.<br />
          If you have any further questions, please contact support.
        </p>
        <div className="flex w-full flex-row items-center justify-center bg-bg-transparent_gray_light p-4">
          <Button className="h-9" text="Close" onClick={onCancel} type="secondary" size="large"  aria-label="Close deleteCompleteModal"/>
        </div>
      </ModalInner>
    </Modal>
  );
};

export default DeleteCompleteModal;